import React, { memo, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectNiveauFilterContent,
  makeSelectNiveauFilterDataArray,
  makeSelectNiveauFilterId,
} from '../selectors';
import { loadCourses } from '../../App/actions';
import { setNiveauFilterDataArray, setNiveauFilterId } from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import FilterElementRadio from '../../../components/FilterElement/FilterElementRadio';

export const Items = ({
  niveauItems,
  onSetNiveauFilterId,
  onLoadCourses,
  niveauFilterId,
  niveauFilterDataArray,
  onSetNiveauFilterDataArray,
}) => {
  useEffect(() => {
    onLoadCourses();
  }, [niveauFilterId]);

  const toggleFilterIds = (item) => {
    const itemIndex = niveauFilterId.indexOf(item.id);
    if (itemIndex >= 0) {
      onSetNiveauFilterId([...niveauFilterId.slice(0, itemIndex), ...niveauFilterId.slice(itemIndex + 1)]);
      onSetNiveauFilterDataArray([
        ...niveauFilterDataArray.slice(0, itemIndex),
        ...niveauFilterDataArray.slice(itemIndex + 1),
      ]);
    } else {
      onSetNiveauFilterId([item.id, ...niveauFilterId]);
      onSetNiveauFilterDataArray([item.name, ...niveauFilterDataArray]);
    }
  };

  if (niveauItems.length === 0) {
    return <></>;
  }

  return niveauItems.map((entry) => {
    const item = Object.entries(entry)[0];
    return (
      <div key={item[1].id} onClick={() => toggleFilterIds(item[1])}>
        <FilterElementRadio
          title={item[1].name}
          status={niveauFilterId.indexOf(item[1].id) >= 0}
          bubble={''}
          position={0}
        />
      </div>
    );
  });
};

Items.propTypes = {
  onLoadCourses: PropTypes.func,
  niveauItems: PropTypes.array,
  onSetNiveauFilterId: PropTypes.func,
  onSetNiveauFilterDataArray: PropTypes.func,
  niveauFilterId: PropTypes.array,
  niveauFilterDataArray: PropTypes.array,
};

Items.defaultProps = {
  onLoadCourses: () => {},
  niveauItems: [],
  onSetNiveauFilterId: () => {},
  onSetNiveauFilterDataArray: () => {},
  niveauFilterId: [],
  niveauFilterDataArray: [],
};

const mapStateToProps = createStructuredSelector({
  niveauItems: makeSelectNiveauFilterContent(),
  niveauFilterId: makeSelectNiveauFilterId(),
  niveauFilterDataArray: makeSelectNiveauFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadCourses: () => dispatch(loadCourses()),
    onSetNiveauFilterId: (value) => dispatch(setNiveauFilterId(value)),
    onSetNiveauFilterDataArray: (value) => dispatch(setNiveauFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(Items);
